export const iconFontAwesomeEmojiFaceSurprise = (
	<i className="fa-solid fa-face-surprise"></i>
);
